import { set } from "lodash";

export class LokiAdvancedSearchController {
    public static $inject: string[] = [
        "$rootScope",
        "$state",
        "lokiFilterService",
        "sitesService",
        "toaster"
    ];

    // Binded
    public isOpen;

    private advancedSearchPartial;

    constructor(
        $rootScope: ng.IRootScopeService,
        $state: ng.ui.IStateService,
        private lokiFilterService,
        public sitesService,
        private toaster
    ) {
        this.advancedSearchPartial = $state.current.data.advancedSearchPartial;

        $rootScope.$on("$stateChangeSuccess", (event, toState) => {
            this.advancedSearchPartial = toState.data.advancedSearchPartial;
        });
    }

    public close() {
        this.isOpen = false;
    }

    public getPartial() {
        return `${ this.advancedSearchPartial }.advanced`;
    }

    public search() {
        this.lokiFilterService.search()
            .then(() => {
                this.isOpen = false;
            })
            .catch(() => {
                this.toaster.toast({
                    message: "Une erreur est survenue. Si le problème persiste, veuillez contacter le support."
                });
            });
    }

    public toggleFilter(isFilterActivate, propertyPath, defaultValue) {
        if (isFilterActivate) {
            set(this.lokiFilterService.filterParams, propertyPath, defaultValue);
        } else {
            set(this.lokiFilterService.filterParams, propertyPath, null);
        }
    }
}
